// src/components/Preview/index.js
import React from 'react';
import PreviewComponent from './PreviewComponent';
import './PreviewRoot.css';

export default function PreviewRoot({ appData }) {
  if (!appData) {
    return (
      <div className="preview-empty">
        <p>No app data available for preview</p>
      </div>
    );
  }

  return (
    <div className="preview-container">
      <PreviewComponent appData={appData} />
    </div>
  );
}